import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { Link, InputControl, FieldsetControl, Row, Col } from '@design-system-etat/dsfr-react';
import * as PropTypes from 'prop-types';
import { getAPI } from 'store/apiReducer';
import { useHistory } from 'react-router-dom';
import usagerClientReducer from '../../../../../../../../store/usagerReducer';
import {
    API_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
    CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
} from '../../../../../../../../constants/apiUrls.constants';
import BoutonEtape from '../../../../../../../../components/form/boutonsEtape/BoutonEtape';
import RoutesRatelier from '../../../../../routes';
import { REGEX_RGA } from '../../../../../../../../constants/contraintes.constants';
import { getPath } from '../../../../../../../../utils/router';

const ArmeCorrigerInformationsEtape1 = ({
    etapeSuivante,
    getApi,
    arme,
    isLoadingGdr,
    dataGdr,
    erreurGdr,
    handleUpdateInformationsArmeData,
}) => {
    const hookForm = useForm({
        mode: 'onchange',
    });
    const { handleSubmit, register, watch } = hookForm;
    const [NumeroRgaErreur, setNumeroRgaErreur] = useState(false);
    const [NumeroRgaValide, setNumeroRgaValide] = useState(false);
    const { REACT_APP_RGA_URL } = process.env;
    const history = useHistory();

    const verifierNouveauNumeroRga = (rga) => {
        getApi(
            usagerClientReducer,
            API_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA + rga,
            CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
        );
    };

    useEffect(() => {
        if (
            watch('nouveauNumeroRga') &&
            REGEX_RGA.exec(watch('nouveauNumeroRga')) &&
            watch('nouveauNumeroRga').length === 5
        ) {
            verifierNouveauNumeroRga(watch('nouveauNumeroRga'));
        }
    }, [watch('nouveauNumeroRga')]);

    useEffect(() => {
        if (watch('nouveauNumeroRga') && watch('nouveauNumeroRga').length === 5) {
            setNumeroRgaErreur(erreurGdr);
            setNumeroRgaValide(!erreurGdr && dataGdr);
        } else {
            setNumeroRgaErreur(false);
            setNumeroRgaValide(false);
        }
    }, [isLoadingGdr, erreurGdr, dataGdr, watch('nouveauNumeroRga')]);

    const retourRatelier = () => {
        history.push(getPath(RoutesRatelier));
    };

    const disableBoutonSuivant = () => {
        return !((watch('nouveauNumeroSerie') && !watch('nouveauNumeroRga')) || NumeroRgaValide);
    };

    const getValeurReelle = (valeur) => {
        return valeur || valeur !== '' ? valeur : null;
    };

    const onSubmit = (dataForm) => {
        if (dataForm) {
            handleUpdateInformationsArmeData({
                nouveauNumeroRga: getValeurReelle(dataForm.nouveauNumeroRga),
                nouveauNumeroSerie: getValeurReelle(dataForm.nouveauNumeroSerie),
            });
            etapeSuivante();
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <FieldsetControl
                id="corriger-informations-arme-numero-rga"
                legend="Correction du numéro Réferentiel Général des armes"
                hintText="Le Référentiel Général des Armes (RGA) est une bibliothèque numérique accessible en ligne régulièrement actualisée, dans laquelle on retrouve pour chaque modèle d’arme, ses caractéristiques techniques et son classement administratif."
            >
                <Row gutters>
                    <Col lg={3} md={6}>
                        <span>
                            <b>N° RGA actuel : </b> {arme.numeroRga}
                        </span>
                    </Col>
                    <Col lg={4} md={6}>
                        <span>
                            <b>Veuillez saisir le nouveau n° RGA :</b>
                        </span>
                    </Col>
                    <Col lg={2} md={6}>
                        <InputControl
                            name="nouveauNumeroRga"
                            type="text"
                            maxlength="5"
                            uppercase
                            {...register('nouveauNumeroRga')}
                            error={
                                NumeroRgaErreur
                                    ? {
                                          message:
                                              'N°RGA non valide, veuillez saisir un n°RGA valide',
                                      }
                                    : null
                            }
                            valid={NumeroRgaValide ? { message: 'Le n° RGA est valide' } : null}
                            isLoading={isLoadingGdr}
                        />
                    </Col>
                    <Col lg={3} md={6}>
                        <Link
                            href={REACT_APP_RGA_URL}
                            icon="fr-fi-arrow-right-line"
                            target="_blank"
                        >
                            Rechercher sur le RGA
                        </Link>
                    </Col>
                </Row>
            </FieldsetControl>
            <FieldsetControl
                id="corriger-informations-arme-numero-serie"
                legend="Correction du numéro de série :"
            >
                <Row gutters>
                    <Col lg={3} md={6}>
                        <span>
                            <b>N° de série actuel : </b>
                            {arme.numeroSerie}
                        </span>
                    </Col>
                    <Col lg={4} md={6}>
                        <span>
                            <b>Veuillez saisir le nouveau n° de série :</b>
                        </span>
                    </Col>
                    <Col lg={2} md={6}>
                        <InputControl
                            name="nouveauNumeroSerie"
                            type="text"
                            {...register('nouveauNumeroSerie')}
                        />
                    </Col>
                    <Col offset={3} md={6} />
                </Row>
            </FieldsetControl>
            <BoutonEtape
                nameBtnSuivant="etapeSuivante"
                labelBtnSuivant="Etape suivante"
                labelBtnPrecedent="Annuler"
                actionPrecedente={retourRatelier}
                btnSuivantDisabled={disableBoutonSuivant()}
            />
        </form>
    );
};

ArmeCorrigerInformationsEtape1.propTypes = {
    etapeSuivante: PropTypes.func.isRequired,
    handleUpdateInformationsArmeData: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    arme: PropTypes.shape({
        numeroRga: PropTypes.string.isRequired,
        numeroSerie: PropTypes.string.isRequired,
    }).isRequired,
    isLoadingGdr: PropTypes.bool,
    dataGdr: PropTypes.object,
    erreurGdr: PropTypes.bool,
    armeCorrigerInformations: PropTypes.shape({
        uuidArme: PropTypes.string.isRequired,
        erreur: PropTypes.string,
    }).isRequired,
};

ArmeCorrigerInformationsEtape1.defaultProps = {
    isLoadingGdr: false,
    dataGdr: null,
    erreurGdr: false,
};

export default connect(
    (state) => {
        const { data: dataArme } = state.repriseDeDonnees.recupererArme;
        const {
            isLoading: isLoadingGdr,
            data: dataGdr,
            erreur: erreurGdr,
        } = state.armes.recupererGdrParNumeroRga;
        return {
            arme: dataArme,
            isLoadingGdr,
            dataGdr,
            erreurGdr,
        };
    },
    {
        getApi: getAPI,
    },
)(ArmeCorrigerInformationsEtape1);
